module.exports = __webpack_public_path__ + "images/brooklyn-3d71c794b6adf1c9787e1fcb89984147.jpg";